module.exports = __webpack_public_path__ + "static/img/qshjjy.d4bcc58b.png";